<template>
  <v-card :elevation="elevation" :class="{ 'pb-4': show }">
    <v-col class="pa-0 pb-2" @click="show = !show">
      <v-card-title class="pt-3 pb-0 cursor-pointer no-selection">
        <v-col class="pa-0 d-flex justify-space-between" cols="12">
          <template v-if="$slots.title">
            <slot name="title"></slot>
          </template>
          <div v-else>
            <span> {{ title }}</span>
          </div>
          <div>
            <v-row class="ma-0">
              <slot name="situacao"></slot>

              <slot name="header-actions" />
              <div class="style-btn-expand">
                <span v-show="!somenteIcone" class="mr-1 ml-4">{{
                  show ? verMenos : verMais
                }}</span>

                <v-btn
                  icon
                  :aria-label="show ? verMenos : verMais"
                  :aria-expanded="show"
                >
                  <v-icon size="36">{{
                    show ? mdiChevronUp : mdiChevronDown
                  }}</v-icon>
                </v-btn>
              </div>
            </v-row>
          </div>
        </v-col>
      </v-card-title>
    </v-col>

    <slot name="conteudo-fixo"></slot>

    <v-expand-transition>
      <div v-if="show">
        <v-card-text class="pt-0 pb-0">
          <slot></slot>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script setup lang="ts">
import { onBeforeMount, ref, watch } from 'vue';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

interface IProps {
  title?: string;
  text?: string;
  elevation?: string | number;
  somenteIcone?: boolean;
  expandido?: boolean;
}

interface IEmits {
  (event: 'change:expandido', e: boolean): void;
}

const props = withDefaults(defineProps<IProps>(), {
  title: '',
  text: '',
  elevation: 2,
  somenteIcone: false,
  expandido: false,
});

const emit = defineEmits<IEmits>();

const show = ref<boolean>(true);

onBeforeMount(() => {
  show.value = props.expandido;
});

const verMais = 'Ver mais';
const verMenos = 'Ver menos';

watch(show, async (newValue, oldValue) => {
  if (newValue != oldValue) {
    emit('change:expandido', newValue);
  }
});

watch(
  () => props.expandido,
  async (newValue, oldValue) => {
    if (newValue != oldValue) {
      show.value = newValue;
    }
  },
  { deep: true }
);
</script>
<style lang="scss" scoped>
.style-btn-expand {
  font-weight: 400;
  font-size: 14px !important;
}
.no-selection {
  user-select: none;
}
</style>
